import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalNotEnabledStep = props => {
  const {
    icon,
    text
  } = props;
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "center",
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(TFlex, {
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      blockSize: "400",
      inlineSize: "400",
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: icon,
        backgroundColor: "icon-core-subtle",
        color: "icon-core-on-fill-default",
        borderRadius: "full",
        size: "400"
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      marginInlineStart: "300",
      textAlign: "start",
      children: text
    })]
  });
};
export default ApprovalNotEnabledStep;